import { render, staticRenderFns } from "./lanIPv6.vue?vue&type=template&id=4edcf7ee&scoped=true&"
import script from "./lanIPv6.vue?vue&type=script&lang=js&"
export * from "./lanIPv6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edcf7ee",
  null
  
)

export default component.exports